import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    Output
} from "@angular/core";

@Component({
    selector: "sps-list-toolbar-search",
    templateUrl: "./sps-list-toolbar-search.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsListToolbarSearchComponent {
    static readonly displayName = "sps-list-toolbar-search";
    static readonly props = {
        formSubmit: { event: true, type: "Event" }
    };

    @HostBinding("class") class = "sps-list-toolbar__search-controls__host";
    @Output() formSubmit = new EventEmitter<Event>();

    handleSubmit(event: Event) {
        event.preventDefault();
        this.formSubmit.emit(event);
    }
}
